




import { Component, Vue } from 'vue-property-decorator';
import { Testimonial } from '../../models/Testimonial';
import { TestimonialTranslation } from '../../models/TestimonialTranslation';
import TestimonialTemplate from './TestimonialTemplate.vue';

@Component({
  components: { TestimonialTemplate },
})
export default class CelebrityTestimonials extends Vue {
  private testimonials: Testimonial[] = [];

  constructor() {
    super();
    this.testimonials = [];
  }

  public mounted() {
    this.$http.get(this.$apiRoutes.supporters).then((response) => {
      response.data.forEach((item: any) => {
        const trans: TestimonialTranslation[] = [];
        item.translations.forEach((t: any) => {
          trans.push(new TestimonialTranslation(t.language, t.text));
        });
        this.testimonials.push(
          new Testimonial({
            image: item.image,
            name: item.name,
            order: item.order,
            translations: trans,
          }),
        );
      });
    });
  }
}
